import React from "react";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center bg-[#0B0B0B] text-white">
      <h1 className="text-6xl font-bold mb-4">404</h1>
      <p className="text-xl mb-8">Oops! Page not found.</p>
      <Link
        to="/"
        className="px-6 py-3 bg-[#B6CB24] text-black rounded-lg hover:opacity-90 transition"
      >
        Go Home
      </Link>
    </div>
  );
};

export default NotFound;
